import React, { useState } from "react";
import axios from "axios";
import "./LocateUs.css";
import PhoneIcon from "@mui/icons-material/Phone";
import MailOutlineIcon from "@mui/icons-material/MailOutline";

const LocateUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNo: "",
    comments: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const dataToSend = {
      id: "", 
      ...formData,
    };

    try {
      const response = await axios.post("http://192.168.0.184:9097/aspiron-backend-adhikrit/api/v1/saveContactForm", dataToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("Form submitted successfully:", response.data);
      alert("Form submitted successfully!");
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Failed to submit the form. Please try again.");
    }
  };

  return (
    <div className="locate-us">
      <h1 className="locate-us-title">Reach Us Enhance your growth</h1>

      <div className="locate-us-content">
        <div className="locate-us-card address-card">
          <h2 className="locate-us-card-title">
            <span className="highlighted-text">A</span>
            spir
            <span className="highlighted-text">o</span>
            n Technologies
            <br />
            <h4>Pvt. Ltd.</h4>
          </h2>
          <p className="address-text">
            Business Square Building,
            <br />
            6th Floor (B and C),
            <br />
            Opposite Hitex Kaman,
            <br />
            Hitech City, Hyderabad – 500081,
            <br />
            Telangana, India.
          </p>
        </div>

        <div className="map-embed">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d951.516917312169!2d78.3757074695599!3d17.45647497830578!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93da776e3347%3A0xd43f52aa73cb4014!2sBizness%20Square!5e0!3m2!1sen!2sin!4v1734351407434!5m2!1sen!2sin"
             title="Map"
            loading="lazy"
            className="google-map"
          ></iframe>
        </div>

        <div className="locate-us-card support-card">
          <h2 className="support-title">Support</h2>
          <p className="support-text">
            <PhoneIcon />
            <b>8142229998</b>
            <br />
            <MailOutlineIcon />
            <b>hr@aspiron.in</b>
            <br />
            <MailOutlineIcon />
            <b>aditya@aspiron.in</b>
          </p>
        </div>
      </div>

      <div className="contact-form">
        <h1>Connect With Us</h1>
        <form onSubmit={handleSubmit}>
          <div className="form-input-container">
            <label htmlFor="name">Name</label>
            <input
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter your full name..."
              required
            />
          </div>
          <div className="form-input-container">
            <label htmlFor="email">Email</label>
            <input
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your proper Email ID..."
              required
            />
          </div>
          <div className="form-input-container">
            <label htmlFor="phoneNo">Mobile Number</label>
            <input
              name="phoneNo"
              value={formData.phoneNo}
              onChange={handleChange}
              placeholder="Enter your Mobile Number..."
              required
            />
          </div>
          <div className="form-input-container">
            <label htmlFor="comments">Description</label>
            <textarea
              name="comments"
              value={formData.comments}
              onChange={handleChange}
              placeholder="Enter your comments..."
              required
            />
          </div>

          <div className="form-submit-container">
            <button type="submit" className="submit-button">Submit</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LocateUs;
